import { ASSET_TYPES } from "../../../enums/assetTypes.enum";
import { isNotNullOrUndefined } from "../../../shared/utils/utils";
import { Address } from "../../shared/address";
import { Position } from "../../shared/position";
import { CustomerRef, TenantRef, AtedBy, Timestamp } from "../../shared/refs";

export interface LocationDTO {
  id?: string;
  label: string;
  assetType?: string | null;
  email?: string | null;
  phone?: string | null;
  length?: number | null;
  width?: number | null;
  height?: number | null;
  surface?: number | null;
  volume?: number | null;
  address?: Address | null;
  expectedEnergyLossPerDay?: number | null;
  expectedEnergyLossPerYear?: number | null;
  customer?: CustomerRef;
  position?: Position;
  severity?: string | null;
  floorMapUrl?: string | null;
  numberOfGateSystems?: number | null;
  numberOfBuildings?: number | null;
  timestamp?: Timestamp;
  tenant?: TenantRef;
  createdBy?: AtedBy;
  updatedBy?: AtedBy;
  notes?: string | null;
}

export class Location {
  id?: string;
  label: string;
  email?: string;
  assetType: string;
  phone?: string;
  notes?: string;
  address?: Address;
  floorMapUrl?: string;
  position?: Position;
  customer?: CustomerRef;
  numberOfBuildings?: number;
  numberOfGateSystems?: number;
  expectedEnergyLossPerDay?: number;

  constructor(location: LocationDTO) {
    if (location.id) this.id = location.id;
    this.label = location.label;
    if (location.customer) this.customer = location.customer;
    if (isNotNullOrUndefined(location.email)) this.email = location.email;
    if (isNotNullOrUndefined(location.phone)) this.phone = location.phone;
    if (isNotNullOrUndefined(location.notes)) this.notes = location.notes;
    if (location.address) this.address = location.address;
    if (location.position) this.position = location.position;
    if (isNotNullOrUndefined(location.numberOfBuildings)) this.numberOfBuildings = location.numberOfBuildings;
    if (isNotNullOrUndefined(location.numberOfGateSystems)) this.numberOfGateSystems = location.numberOfGateSystems;
    if (location.floorMapUrl) this.floorMapUrl = location.floorMapUrl ?? undefined;
    if (isNotNullOrUndefined(location.expectedEnergyLossPerYear))
      this.expectedEnergyLossPerDay =
        location.expectedEnergyLossPerYear !== undefined ? location.expectedEnergyLossPerYear / 365 : undefined;
    this.assetType = ASSET_TYPES.LOCATION;
  }

  public set properties(location: LocationDTO) {
    this.label = location.label;
    if (isNotNullOrUndefined(location.email)) this.email = location.email;
    if (isNotNullOrUndefined(location.phone)) this.phone = location.phone;
    if (isNotNullOrUndefined(location.notes)) this.notes = location.notes;
    if (location.address) this.address = location.address;
    if (location.position) this.position = location.position;
  }

  public set floorMap(floorMapUrl: string) {
    this.floorMapUrl = floorMapUrl;
  }
  public get directParentId() {
    return this.customer?.id;
  }

  public get values() {
    const location: LocationDTO = {
      label: this.label,
      customer: this.customer,
    };
    // if (this.id) {
    //   location.id = this.id;
    // }
    if (this.address) {
      if (
        this.address.street &&
        this.address.number &&
        this.address.city &&
        this.address.country &&
        this.address.zipCode
      ) {
        location.address = this.address;
        if (!this.address.street) {
          delete location.address.street;
        }
        if (!this.address.number) {
          delete location.address.number;
        }
        if (!this.address.city) {
          delete location.address.city;
        }
        if (!this.address.country) {
          delete location.address.country;
        }
        if (!this.address.zipCode) {
          delete location.address.zipCode;
        }
      }
    }
    if (this.floorMapUrl) {
      location.floorMapUrl = this.floorMapUrl;
    }
    if (isNotNullOrUndefined(this.email)) {
      location.email = this.email;
    }

    if (isNotNullOrUndefined(this.phone)) {
      location.phone = this.phone;
    }
    if (this.position && this.position.latitude && this.position.longitude) {
      location.position = this.position;
    }
    if (isNotNullOrUndefined(this.notes)) {
      location.notes = this.notes;
    }

    return location;
  }
}
